/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Notes/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AgGrid from 'DesignSystem/AgGrid/react'
import FilterBy from './FilterBy/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Notes({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Notes",
  height,
  columnDefs,
  rowData
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
  return (<React.Fragment
>
<div
  data-testid="Notes.Vertical"
  data-view-path={viewPath}
 style={{'--pl-1-5rqsf': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-5rqsf': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-3-5rqsf': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-4-5rqsf': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bc-5-5rqsf': dtColorsWhite}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Notes.Vertical:1"
  data-view-path={viewPath}
 style={{'--btc-6-5rqsf': dtColorsNeutral200,'--bc-5-5rqsf': dtColorsWhite}}
 className={`views-block ${styles.Vertical1}`}
>
<AgGrid
  viewPath={`${viewPath}/AgGrid`}
 disableAutoSizeStrategy={true}
 height={height}
 headerHeight={36}
 rowHeight={44}
 rowGroupPanelShow="never"
 verticalBorders={true}
 overlayNoRowsTemplate="No notes found"
 columnDefs={columnDefs}
 rowData={rowData}
 suppressCellFocus={true}
/>
</div>
</div>
<FilterBy
  viewPath={`${viewPath}/FilterBy`}
/>
{children}
</React.Fragment>)
}